import { FlexSheetMapper } from './flex-sheet-mapper';
import { Mapper } from '../../../_models/_interfaces/mapper';
import { SimulationVariable } from '../../../_models';
import { NumberToSimulationVariableMapper } from './number-to-simulation-variable-mapper';
import { ThirdPartyRefinery } from '../../../_models/_unit-operations/third-party-refinery';
import { ThirdPartyRefinerySheetRows } from '../cell-config/third-party-refinery-cell-config';

export class ThirdPartyRefineryFlexSheetMapper implements FlexSheetMapper {
  simulationVariableMapper: Mapper<number, SimulationVariable>;

  constructor(simulationVariableMapper: NumberToSimulationVariableMapper) {
    this.simulationVariableMapper = simulationVariableMapper;
  }

  map(unitOperation: ThirdPartyRefinery, row: number, value: string | number) {
    if (row === ThirdPartyRefinerySheetRows.NAME && typeof value === 'string') {
      unitOperation.name = value;
    }

    if (typeof value === 'number') {
      switch (row) {
        case ThirdPartyRefinerySheetRows.LIGHT_ENDS_MARGIN:
          this.simulationVariableMapper.map(value, unitOperation.lightEndsMargin);
          break;

        case ThirdPartyRefinerySheetRows.NAPHTHA_MARGIN:
          this.simulationVariableMapper.map(value, unitOperation.naphthaMargin);
          break;

        case ThirdPartyRefinerySheetRows.DISTILLATE_MARGIN:
          this.simulationVariableMapper.map(value, unitOperation.distillateMargin);
          break;

        case ThirdPartyRefinerySheetRows.GAS_OIL_MARGIN:
          this.simulationVariableMapper.map(value, unitOperation.gasOilMargin);
          break;

        case ThirdPartyRefinerySheetRows.VACUUM_RESIDUE_MARGIN:
          this.simulationVariableMapper.map(value, unitOperation.vacuumResidueMargin);
          break;

        case ThirdPartyRefinerySheetRows.CAPACITY:
          this.simulationVariableMapper.map(value, unitOperation.capacity);
          break;
      }
    }
  }
}
